// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.not-found{
  margin-top:2rem;
}
.not-found__thumb{
    width:9.625rem;
    margin:1rem auto 1rem;
  }
.not-found__message1{
    text-align:center;
    font-size:1.25rem;
    line-height:1.875rem;
  }
.not-found__message2{
    text-align:center;
    font-size:1.125rem;
    line-height:1.75rem;
  }
.not-found__menu{
    width:7.375rem;
    padding:0;
    margin:auto auto 1rem;
    list-style:none;
  }
.not-found__menu__item{
      margin-bottom:0.5rem;
    }
@media (width <= 640px){
    .not-found__message1{
      padding:0 2.1875rem 0 2.1875rem;
    }

    .not-found__message2{
      padding:0 3.75rem 0 3.75rem;
    }
  }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
